import {
  FocusContext,
  FocusableComponentLayout,
  useFocusable,
} from '@noriginmedia/norigin-spatial-navigation'
import React, { useCallback, useState } from 'react'
import cx from 'classnames'
import { platformTransitionStyle } from '../../../../shared/helpers'

import type { CollectionLanesProps } from './types'

const COLLECTIONS_SET_PADDING_TOP = 227

const CollectionLanes = <T,>({
  collections,
  singleRow = false,
  children,
  hasHeaderComponent = false,
  className = '',
}: CollectionLanesProps<T>) => {
  const [translateY, setTranslateY] = useState(0)
  const classes = cx('collections-set', { [className]: !!className })

  const { ref, focusKey } = useFocusable({
    onBlur: () => {
      hasHeaderComponent && setTranslateY(0)
    },
  })

  const handleCarouselFocus = useCallback(
    (layout: FocusableComponentLayout) => {
      if (!singleRow) {
        setTranslateY(-(layout.top - COLLECTIONS_SET_PADDING_TOP))
      }
    },
    [setTranslateY, singleRow]
  )

  return (
    <FocusContext.Provider value={focusKey}>
      <div
        ref={ref}
        className={classes}
        style={{
          transform: `translateY(${translateY}px)`,
          transition: platformTransitionStyle('transform 500ms ease-in-out'),
        }}
      >
        {collections.length > 0
          ? collections.map((collection, index) =>
              children(collection, handleCarouselFocus, index)
            )
          : null}
      </div>
    </FocusContext.Provider>
  )
}

export default CollectionLanes
